import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { Store } from '../../../store/player/types';

export const toggleJumpStart = (store: Store): void => {
  const { isJumpStartActive, setIsJumpStartActive } = store.getState();

  setIsJumpStartActive(!isJumpStartActive);
  LocalStorage.set('playbackJumpStart', !isJumpStartActive);
};
